var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Gen-AI"},[_c('AiChatBot',{attrs:{"loading":_vm.isLoading,"prompt":_vm.prompt,"list":_vm.list},on:{"send":_vm.sendMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }